/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Phone/view.blocks to change it.
import Fields from './Fields/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Phone({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Professionals/AddAction/New/Content/Phone"
  
}) {
  return (<React.Fragment
>
<Fields
  viewPath={`${viewPath}/Fields`}
/>
{children}
</React.Fragment>)
}